import { gql } from '../../../__generated__';

export const DELETE_ACCOUNT = gql(`
  mutation DeleteAccountWeb {
    deleteAccountWeb {
      message
    }
  }
`);

export const LOGOUT = gql(`
  mutation Mutation {
    logoutWeb {
      message
      status
    }
  }
`);
